import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Queue from 'promise-queue/lib';
import { getCurrentVersionName, setCurrentVersionName } from '../../shared/version.name.helper';
import { VersionService } from '../../version/version.service';

@Component({
  selector: 'app-question-help',
  templateUrl: './question-help.component.html',
  styleUrls: ['./question-help.component.scss'],
})
export class QuestionHelpComponent implements OnInit, OnDestroy {
  constructor(
    private versionService: VersionService,
    public router: Router,
    public route: ActivatedRoute,
  ) {}

  get versionName() {
    return this._versionName;
  }
  set versionName(name) {
    this._versionName = name;
    this.router.navigate(['/question/help'], { queryParams: { versionName: this.versionName } });
    this.load();
    setCurrentVersionName(name);
  }

  _versionName = '';
  versions;

  items;

  imageQueue: Queue = new Queue(3, Infinity);

  async ngOnInit() {
    await new Promise<void>(res => {
      this.route.queryParamMap.subscribe(async queryParamMap => {
        const queryVersion = queryParamMap.get('versionName');
        this.versions = await this.versionService.list();

        if (queryVersion) {
          this.versionName = queryVersion;
        } else {
          const storedVersion = getCurrentVersionName();
          this.versionName = storedVersion || this.versions[0].name;
        }
        res();
      });
    });

    this.load();
  }

  async load() {
    this.imageQueue.queue = [];
    const latest = await this.versionService.latest(this.versionName);
    const tree = await this.versionService.tree(latest.id);
    this.items = tree.items.filter(item => {
      item.sections = item.sections.filter(section => {
        section.questions = section.questions.filter(question => question.helpText);
        return section.questions.length;
      });
      return item.sections.length;
    });
  }

  ngOnDestroy() {
    // clear request queue
    this.imageQueue.queue = [];
  }

  prepare(str) {
    if (str) {
      return str.replace(/\n/g, '<br />');
    }
  }
}
